import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import AppRoutes from '@/routes';
import { fetchMe } from '@/redux/slices/authSlice';

// Top-level app: validates/refreshes the admin session on load, then renders the route tree.
export default function App() {
  const dispatch = useDispatch();
  const token = useSelector((s) => s.auth.token);

  useEffect(() => {
    // If we have a stored token, confirm it's still valid and refresh permissions.
    if (token) dispatch(fetchMe());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <AppRoutes />;
}
